import React, { useState } from "react";
import InsideHeader from "../../../../components/InsideHeader";
import svg100 from "../../../../assets/svg/svg100.svg";
import svg101 from "../../../../assets/svg/svg101.svg";
import svg80 from "../../../../assets/svg/svg80.svg";
import deleteSvg from "../../../../assets/svg/delete-red.svg";
import { Descriptions, Divider, Table } from "antd";
import moment from "moment";
import PanelTable from "./PanelTable";
import Candidates from "./Candidates";
import { useDispatch, useSelector } from "react-redux";
import ConfirmModal from "../../../../components/ConfirmModal";
import { Navigate, useNavigate } from "react-router-dom";
import { save } from "../../../../features/save/saveSlice";
import toast from "react-hot-toast";

function ActivityView() {
  const { activeObjActivity } = useSelector((state) => ({
    activeObjActivity: state.folder.activeObj["activity"],
  }));
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { saving } = useSelector((state) => state.save);
  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };
  const handleDelete = async () => {
    const res = await dispatch(
      save({
        url: `api/v1/activities/delete/${activeObjActivity?.jaaId}`,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await navigate("/recruitment/activity-list");
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  const handleEdit = () => {
    navigate("/recruitment/activity-stepper");
  };
  const items1 = [
    {
      key: "6",
      label: "Date",
      children: (
        <div>
          {activeObjActivity?.jaaStartDate
            ? moment(activeObjActivity?.jaaStartDate)?.format("DD-MM-YYYY")
            : "--"}
        </div>
      ),
    },
    {
      key: "1",
      label: "Location",
      children: activeObjActivity?.jaaLocation ?? "N/A",
    },
    {
      key: "3",
      label: "Assigned",
      children: (
        <div className="flex flex-col gap-[.5rem]">
          <div className="bg-[#F4F3F3] py-[.5rem] px-[1rem] gap-[.25rem] flex items-center justify-center rounded-[1.75rem]">
            {activeObjActivity?.jaaAssigneeName}
          </div>
        </div>
      ),
    },
    {
      key: "4",
      label: "Description",
      children: activeObjActivity?.jaaDesc ?? "N/A",
    },
  ];
  return (
    <>
      <div className="w-full h-full overflow-y-scroll">
        <InsideHeader
          title="Activity View"
          subtitle="Have a view of your activity"
          back={true}
          title1="Activities"
          title2="View Activity"
        />

        <div className="white_card mt-[1.5rem] font-dmSans">
          <div className="text-lightBlack text-[2rem] font-[500] ">
            Interview
          </div>
          <div className="text-[#706F6F] text-[1.125rem] font-[500]">
            {activeObjActivity?.jaaTitle}
          </div>
          <div className="flex items-center justify-between text-[#706F6F] text-[1.125rem] font-[500] mt-[1rem]">
            <div className="flex items-center gap-[1rem]">
              <div className="flex items-center gap-[.5rem]">
                <img src={svg100} alt="svg100" />
                <span>
                  {activeObjActivity?.jaaStartDate
                    ? moment(activeObjActivity.jaaStartDate).format(
                        "DD-MM-YYYY"
                      )
                    : "--"}
                </span>
              </div>
              <div className="flex items-center gap-[.5rem]">
                <img src={svg101} alt="svg101" />

                <span>{activeObjActivity?.jaaLocation}</span>
              </div>
            </div>

            <div className="flex items-center gap-[1rem]"> 
                <img
                  src={svg80}
                  alt="svg80"
                  className="cursor-pointer"
                  onClick={handleEdit}
                /> 
              {/* {activeObjActivity === "DRAFT" && (
                <img
                  src={svg80}
                  alt="svg80"
                  className="cursor-pointer"
                  onClick={handleEdit}
                />
              )} */}

              <img
                src={deleteSvg}
                alt="deleteSvg"
                className="cursor-pointer"
                onClick={handleOpenDelete}
              />
            </div>
          </div>

          <Divider />

          <div className="text-lightBlack text-[1.5rem] font-[600] my-[1rem]">
            Activity Setting
          </div>

          <Descriptions
            title=""
            column={2}
            colon={false}
            items={items1}
            layout="vertical"
          />

          <PanelTable />

          <div className="text-lightBlack text-[1.5rem] font-[600] mt-[1.5rem]">
            Activity Scheduling
          </div>

          <Candidates />
        </div>
      </div>

      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={saving}
        content={`Are you sure you want to delete`}
        type="alert"
        btnTitle="Confirm"
      />
    </>
  );
}

export default ActivityView;
